import React, { useEffect, useState, useContext, useMemo } from "react";
import { Container, Row, Col, Spinner, Modal, Form } from "react-bootstrap";
import GlobalContext from "../../GlobalContext";
import InfoIcon from "@mui/icons-material/Info";
import { Tooltip } from "@mui/material";
import { useMyContext } from "../../MyContext";
import { useDataCache } from "../../DataCacheContext";

//Components
import TopMargin from "../TopMargin";
import RowMargin from "../RowMargin";
import SuperAppButton from "../SuperAppButton";
import { MdDelete } from "react-icons/md";
import ShowAgent from "../ShowAgent";
import SuperAppObject from "./SuperAppObject";
import likeImage from "./like_PNG17.png";
import { evaluateDynamicLogic, capitalize, evaluateCondition } from "./utils";
import { fetchSecure } from "./utils";
import SecureImage from "../SecureImage";
import "../../index.css";
import { IconsDetails } from "../CustomChatbotIcons";
import MCPClientUI from "../../pages/mcp-gateway";
import { convertCamelToDisplayName } from "../../utils/utils";
import {
  CardPreview,
  ItineraryWidget,
} from "../integration_components/integrationUtils";
import { renderTable } from "../../utils/TableRenderer";
import { isMobile } from "react-device-detect";
import ActionAccordionDesktop from "../ActionAccordionDesktop";
import ActionAccordionMobile from "../ActionAccordionMobile";
import MultiHtmlContent from "../multiHtmlContent";
import TextareaList from "../TextArealist";

const envName = process.env.REACT_APP_ENV_NAME;

var trackingConfig = {
  collection: "tracking",
  buttonName: "Save Comment",
  fields: [
    {
      placeholder: "",
      display_name: "ID",
      name: "remoteID",
      input_type: "text",
      default: "{ID}",
      required: true,
    },
    {
      placeholder: "",
      display_name: "Tracking Type",
      name: "trackingType",
      input_type: "dropdown",
      values: ["Comment"],
      required: true,
    },
    {
      placeholder: "",
      display_name: "Short Description",
      name: "trackingShortDescription",
      input_type: "text",
      required: true,
    },
    {
      placeholder: "",
      display_name: "Comment",
      name: "trackingText",
      input_type: "textarea",
      required: true,
    },
  ],
  table: [
    {
      selector: (row) => row.trackingType,
      name: "Action",
      sortable: true,
      minWidth: "20%",
    },
    {
      selector: (row) => row.trackingShortDescription,
      name: "Description",
      sortable: true,
      minWidth: "60%",
      wrap: true,
    },
    {
      selector: (row) => row.trackingDate,
      name: "Date",
      wrap: true,
      sortable: true,
      sortOrder: "asc",
      minWidth: "20%",
    },
  ],
  filterField: "trackingShortDescription",
  exportFields: [],
  otherTableOptions: { paginationPerPage: 20 },
  actions: "create",
};

var quickRepliesConfig = {
  collection: "quickReplies",
  buttonName: "",
  security: {
    create: "AllUsers",
    edit: "AllUsers",
    delete: "AllUsers",
    view: "AllUsers",
  },
  fields: [
    {
      placeholder: "",
      display_name: "Content",
      name: "content",
      input_type: "text",
      default: "",
      required: true,
    },
    {
      placeholder: "",
      display_name: "Type",
      name: "type",
      input_type: "text",
      default: "prompt",
      required: true,
    },
  ],
  table: [
    {
      selector: (row) => row.content,
      name: "Content",
      sortable: true,
      minWidth: "20%",
    },
    {
      selector: (row) => row.type,
      name: "Type",
      sortable: true,
      minWidth: "20%",
    },
  ],
  filterField: "content",
  exportFields: [],
  otherTableOptions: { paginationPerPage: 20 },
  actions: "create",
};

const back = (props) => {
  //setTimeout(() => { props.loadObjects() }, 1000)
  props.loadObjects();
  props.setDisplayState("TABLE");
  props.setActionType("DISPLAY");
};

export default function DisplayDetails(props) {
  const globalData = useContext(GlobalContext);

  const myContext = useMyContext();
  const superAppStyle = useContext(GlobalContext)["superAppStyle"];
  const [showAddComment, setShowAddComment] =
    useState(false); /* KAD added Jan 26, 2025 */
  const [comment, setComment] = useState(""); /* KAD added Jan 26, 2025 */
  const debug = myContext["data"]["debugOn"];
  const [isShow, setIsShow] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0); //Vik (Jul 4, 2025): To set key for refreshing the chat iframe
  const [validated, setValidated] =
    useState(false); /* for Bootstrap form validation */
  const [validationString, setValidationString] =
    useState(
      ""
    ); /* KAD put this in April 11, 2022 because people weren't entering all the required fields and Typeahead required NOT working like Form Controls */
  const [actionType, setActionType] = useState(props.actionType);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [displayArray, setDisplayArray] = useState([]);
  const [showAllRows, setShowAllRows] = useState(false);
  const [formData, setFormData] = useState({
    data: props.thisObject,
    status: "IDLE",
  });
  const [attachments, setAttachments] = useState([]);
  const [scanning, setScanning] = useState(false);
  const [expandedCells, setExpandedCells] = useState({}); // Track expanded cells
  const [deletingFiles, setDeletingFiles] = useState({}); // Track deleting files
  const [isLoadingApiKey, setIsLoadingApiKey] = useState(false);
  const [isReindexing, setIsReindexing] = useState(false);

  const toggleExpandCell = (rowIndex, fieldKey) => {
    setExpandedCells((prev) => ({
      ...prev,
      [`${rowIndex}-${fieldKey}`]: !prev[`${rowIndex}-${fieldKey}`],
    }));
  };

  const { dataCache, setDataCache } =
    useDataCache(); /* KAD added Feb 26, 2025 */
  const [isDocumentEqual, setIsDocumentEqual] =
    useState(true); /*Vik(May 16, 2025): To disable/enable publish button */

  useEffect(() => {
    if (props.thisObject) {
      //console.log("🚀 ~ DisplayDetails ~ props.thisObject:", props.thisObject);
      setFormData({
        data: props.thisObject,
        status: "IDLE",
      });
    } else {
      setFormData({
        data: {},
        status: "IDLE",
      });
    }
    //console.log("🚀 ~ DisplayDetails ~ formData:", formData)
  }, []);

  useEffect(() => {
    if (formData.data["attachments"]) {
      //console.log(
      //  `🚀 ~ useEffect ~ formData.data["attachments"]:`,
      //  formData.data["attachments"]
      //);
      setAttachments(formData.data["attachments"]);
    }
  }, [formData.data]);

  const handleFileDelete = async (fileId) => {
    setDeletingFiles((prev) => ({ ...prev, [fileId]: true }));
    try {
      const response = await fetchSecure(
        "/api/deleteFile/" + props.userDeep.id + "/" + fileId
      );
      const data = await response.json();

      if (data?.hasOwnProperty("message")) {
        console.log("success");
        // Create a shallow copy of the data object
        const copyData = { ...formData.data };
        // Filter out the attachment that matches the fileId
        const filteredArray = copyData.attachments.filter(
          (file) => file.fileName !== fileId
        );
        copyData.attachments = filteredArray;
        setFormData((prevData) => ({
          ...prevData,
          data: copyData,
        }));
        setAttachments(filteredArray);
        refreshDetails();
      } else {
        console.log("failed");
      }
    } catch (error) {
      console.error("File deletion failed:", error);
    } finally {
      setDeletingFiles((prev) => ({ ...prev, [fileId]: false }));
    }
  };

  var filesConfig = {
    collection: "files",
    buttonName: "",
    fields: [
      {
        placeholder: "",
        display_name: "File Name",
        name: "fileName",
        input_type: "text",
        link: "/getFile/[shortFileName]",
        default: "{ID}",
        required: true,
      },
    ],
    table: [
      {
        selector: (row) => row.shortFileName,
        name: "File Name",
        sortable: true,
        minWidth: "20%",
      },
      {
        // Delete button column, renders Spinner during deletion or MdDelete icon
        cell: (row) =>
          deletingFiles[row.fileName] ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <MdDelete
              className="delete-icon"
              onClick={() =>
                window.confirm("Are you sure you wish to delete this file?") &&
                handleFileDelete(row.fileName)
              }
              id={row.fileName}
              size={30}
            />
          ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        minWidth: "10%",
      },
    ],
    filterField: "fileName",
    exportFields: [],
    otherTableOptions: { paginationPerPage: 20 },
    actions: "create",
  };

  //console.log(JSON.stringify(props));
  const arrayChunk = (arr, n) => {
    var colCounter = 0;
    var colArray = [];
    var rowArray = [];
    for (let x = 0; x < arr.length; x++) {
      var element = arr[x];
      if (element.input_type === "none") {
        x++;
        element = arr[x];
      }

      var colspan = 1;
      if ("colspan" in element) {
        colspan = element["colspan"];
        if (colspan === 3) colCounter = n - 1;
        if (colspan + colCounter >= n) {
          colCounter = n - 1;
        }
      }
      colArray.push(element);
      colCounter++;
      if (colCounter === n) {
        rowArray.push(colArray);
        colArray = [];
        colCounter = 0;
      }
    }
    rowArray.push(colArray);
    return rowArray;
  };
  // const arrayChunkNew = (arr, n) => {
  //   const tabs = [];
  //   let currentRow = [];
  //   let currentTab = null;

  //   for (const element of arr) {
  //     if (element.header && element.type === "tab") {
  //       /* KAD added tab check Sept 6, 2025 */
  //       // Start a new tab
  //       if (currentTab) {
  //         currentTab.rows.push(currentRow); // Add the last row to the previous tab
  //         tabs.push(currentTab); // Add the completed tab
  //       }
  //       currentTab = { title: element.header || "Untitled Tab", rows: [] }; // Use label or default title
  //       currentRow = []; // Start a new row for the new tab
  //       continue; // Skip the header element itself in the row data
  //     }

  //     if (element.input_type === "none") {
  //       continue; // Skip "none" elements
  //     }

  //     let colspan = 1;
  //     if ("colspan" in element) {
  //       colspan = element.colspan;
  //     }

  //     currentRow.push(element);

  //     if (currentRow.length === n) {
  //       if (!currentTab) {
  //         currentTab = { title: "Untitled Tab", rows: [] }; // Create default tab if no headers are found
  //       }
  //       currentTab.rows.push(currentRow);
  //       currentRow = [];
  //     }
  //   }

  //   // Add the last tab and any remaining row
  //   if (currentTab) {
  //     if (currentRow.length > 0) {
  //       currentTab.rows.push(currentRow);
  //     }
  //     tabs.push(currentTab);
  //   } else if (currentRow.length > 0) {
  //     // Handle the case where there were no headers and we have rows
  //     const defaultTab = { title: "Untitled Tab", rows: [currentRow] };
  //     tabs.push(defaultTab);
  //   }

  //   return tabs;
  // };

  // Pure, non-mutating: builds tabs from config.fields using headers with type:'tab'.
  // Ensures no empty rows get pushed and does not modify the incoming array.
  // Also guards against accidental duplication by keeping rows stable.
  const arrayChunkNew = (arr, n) => {
    const tabs = [];
    let currentRow = [];
    let currentTab = null;

    // Work on a shallow copy to be extra safe against upstream mutation side-effects
    const input = Array.isArray(arr) ? [...arr] : [];

    for (const element of input) {
      // Start a new tab when we see a header with type:'tab'
      if (element && element.header && element.type === "tab") {
        if (currentTab) {
          if (currentRow.length > 0) currentTab.rows.push(currentRow);
          tabs.push(currentTab);
        }
        currentTab = { title: element.header || "Untitled Tab", rows: [] };
        currentRow = [];
        continue; // skip the header element itself
      }

      if (!element || element.input_type === "none") continue;

      // Respect colspan visually but keep row packing to n cells (3) like before
      currentRow.push(element);
      if (currentRow.length === n) {
        if (!currentTab) currentTab = { title: "Untitled Tab", rows: [] };
        currentTab.rows.push(currentRow);
        currentRow = [];
      }
    }

    // Flush the last row/tab
    if (currentTab) {
      if (currentRow.length > 0) currentTab.rows.push(currentRow);
      tabs.push(currentTab);
    } else if (currentRow.length > 0) {
      tabs.push({ title: "Untitled Tab", rows: [currentRow] });
    }

    // Return as-is (no global dedupe to avoid hiding intended repeats)
    return tabs;
  };

  const [activeTab, setActiveTab] = useState(0);
  // const tabs = arrayChunkNew(props.config.fields, 3); // 3 elements per row
  const tabs = useMemo(() => {
    // build once per config.fields change (prevents accidental carry-over across renders)
    return arrayChunkNew(props.config.fields, 3);
  }, [props.config.fields]);

  const handleCopyClick = async (text) => {
    try {
      await window.navigator.clipboard.writeText(text);
      console.log(text);
      alert("Copied to clipboard!");
    } catch (err) {
      console.error("Unable to copy to clipboard.", err);
      alert("Copy to clipboard failed.");
    }
  };

  /* KAD added Feb 20, 2025 */
  /* TODO KADFIX...move this to a property passed in */
  function canUploadFiles(props) {
    if (
      "flags" in props.config &&
      props.config.flags.indexOf("attachments") >= 0 &&
      (formData.data["agentType"] === "DOCUMENT_QA" ||
        formData.data["agentType"] === "FAQ" ||
        formData.data["agentType"] ===
          "COMBINATION_AGENT" /* KAD added April 7, 2025 */ ||
        formData.data["agentType"] === "ANALYTICS_AGENT")
    )
      return true;
    return false;
  }

  /* KAD added these for Config Editor use case Feb 12, 2025 */
  function canRefresh(props) {
    if (props.dontPersistData) return false;
    return true;
  }

  function canClone(props, config, rowData) {
    if (props.dontPersistData) return false;
    if (
      config.security &&
      config.security.clone &&
      config.security.clone.indexOf("AllUsers") >= 0
    )
      return true;

    if (
      config.security &&
      config.security.clone &&
      config.security.clone.indexOf("createdBy") >= 0 &&
      props.user &&
      rowData.createdBy &&
      props.user === rowData.createdBy
    )
      return true;
  }

  /* KAD added these for Config Editor use case Feb 12, 2025 */
  function canGoBack(props) {
    if (props.dontPersistData) return false;
    if (props.hideBackButton === true) return false;
    return true;
  }

  function canEdit(props, config, rowData) {
    if (props.canEdit === "false") return false;

    if (
      props.userDeep &&
      props.userDeep.roles &&
      props.userDeep.roles.toLowerCase().indexOf("edit") >= 0
    )
      return true;

    if (
      config.security &&
      config.security.edit &&
      config.security.edit.indexOf("AllUsers") >= 0
    )
      return true;

    if (
      config.security &&
      config.security.edit &&
      config.security.edit.indexOf("createdBy") >= 0 &&
      props.user &&
      rowData.createdBy &&
      props.user === rowData.createdBy
    )
      return true;

    return false;
  }
  const editRecord = () => {
    props.setDisplayState("CREATE_EDIT");
    props.setActionType("EDIT");
    props.setActiveTab(
      activeTab
    ); /* KAD added this Feb 19, 2025 so the Edit would edit the same tab when drawn */
  };

  /* Have to keep this logic consistent with a copy in CreateEdit, TODO: move to a shared library  */
  function canDeleteRow(props, config, rowData) {
    /* KAD added this if statement to support the Config Editor use case Feb 12, 2025..I am not going to allow deletes in the Display mode...just makes it harder */
    if (props.dontPersistData) return false;
    if (
      config.security &&
      config.security.delete &&
      config.security.delete.indexOf("system_admin") >= 0
    )
      return true;

    if (
      config.security &&
      config.security.delete &&
      config.security.delete.indexOf("None") >= 0
    )
      return false;

    if ("locked" in rowData && rowData["locked"] === true) return false;

    /* To prevent deletion of WiX created agent from non WiX site. Vik March 21, 2025 */
    if (
      !!rowData.wixInstanceId &&
      (!document.referrer.includes("wix.com") ||
        !document.referrer.includes("wixsite.com"))
    ) {
      return false;
    }

    if (
      props.userDeep &&
      props.userDeep.roles &&
      props.userDeep.roles.toLowerCase().indexOf("delete") >= 0
    )
      return true;

    if (
      config.security &&
      config.security.delete &&
      config.security.delete.indexOf("AllUsers") >= 0
    )
      return true;

    if (
      config.security &&
      config.security.delete &&
      config.security.delete.indexOf("createdBy") >= 0 &&
      props.user &&
      rowData.createdBy &&
      props.user === rowData.createdBy
    )
      return true;

    return false;
  }

  const handleDelete = async () => {
    // NEED SOME ERROR HANDLING HERE
    if (formData.data.locked === true) {
      window.confirm("This record is locked. You cannot delete it.");
      return;
    }
    // /* To prevent deletion of WiX created agent from non WiX site. Vik March 21, 2025 */
    // if (
    //   !!formData.data.wixInstanceId &&
    //   (!document.referrer.includes("wix.com") ||
    //     !document.referrer.includes("wixsite.com"))
    // ) {
    //   window.confirm("You cannot delete it.");
    //   return;
    // }

    if (globalData.debug)
      console.log(props.config.collection, "," + formData.data.id);
    await fetchSecure(
      "api/deleteObject/" +
        props.config.collection +
        "/" +
        formData.data.id +
        "/" +
        props.user
    )
      .then((response) => response.json())
      .then((data) => {
        if (globalData.debug) console.log(data);

        /* Update dataCache for agent or integration deletion. Vik, APR 15, 2025 */
        if (
          props.config.collection === "agents" ||
          props.config.collection === "integrations"
        ) {
          if (props.config.collection === "agents" && data.success) {
            const updatedAgents =
              dataCache.agents?.filter(
                (agent) => agent.id !== formData.data.id
              ) || [];
            const updatedAgentsLookup = { ...dataCache.agentsLookup };
            delete updatedAgentsLookup[formData.data.id];
            setDataCache({
              ...dataCache,
              agents: updatedAgents,
              agentsLookup: updatedAgentsLookup,
            });
            if (globalData.debug) {
              console.log("Updated dataCache after agent deletion:", {
                agents: updatedAgents,
                agentsLookup: updatedAgentsLookup,
              });
            }
          } else if (
            props.config.collection === "integrations" &&
            data.success
          ) {
            const updatedIntegrations =
              dataCache.integrations?.filter(
                (integration) => integration.id !== formData.data.id
              ) || [];
            const updatedIntegrationsLookup = {
              ...dataCache.integrationsLookup,
            };
            delete updatedIntegrationsLookup[formData.data.id];
            setDataCache({
              ...dataCache,
              integrations: updatedIntegrations,
              integrationsLookup: updatedIntegrationsLookup,
            });
            if (globalData.debug) {
              console.log("Updated dataCache after integration deletion:", {
                integrations: updatedIntegrations,
                integrationsLookup: updatedIntegrationsLookup,
              });
            }
          }
        }

        setTimeout(() => {
          props.loadObjects();
        }, 1000);
      })
      .catch(function (error) {
        console.log(error);
      });

    //setTimeout(() => {props.loadObjects()}, 5000)
    props.setDisplayState("TABLE");
    props.setActionType("DISPLAY");
  };

  const handleClone = async () => {
    // NEED SOME ERROR HANDLING HERE

    if (globalData.debug)
      console.log(props.config.collection, "," + formData.data.id);
    await fetchSecure(
      "api/cloneObject/" +
        props.config.collection +
        "/" +
        formData.data.id +
        "/" +
        props.user
    )
      .then((response) => response.json())
      .then((data) => {
        if (globalData.debug)
          console.log("Result from clone = " + JSON.stringify(data));
      })
      .catch(function (error) {
        console.log(error);
      });

    setTimeout(() => {
      props.loadObjects();
    }, 1000);
    props.setDisplayState("TABLE");
    props.setActionType("DISPLAY");
  };

  const handleReIndex = async () => {
    try {
      setIsReindexing(true);
      console.log("formData.data.id", formData.data.id);
      const response = await fetchSecure("/api/reindex", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: formData.data.id }),
      });

      const data = await response.json();

      if (data.success) {
        alert(data.message || "Reindexing was successful");
      } else {
        alert(data.message || "Failed to re-index documents");
      }
    } catch (error) {
      console.log("Error: Unable to connect to the server");
    } finally {
      setIsReindexing(false);
    }
  };

  /* Vik (Jul 30, 2025): Function to handle generating api of the object */

  const handleGenerateApiKey = async () => {
    try {
      setIsLoadingApiKey(true); // Set loading state
      const response = await fetchSecure("/api/generateApiKey", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          agentId: formData.data.id,
          userId: props.user,
        }),
      });
      const data = await response.json();

      if (globalData.debug) {
        console.log(`Result from generate API key = ${JSON.stringify(data)}`);
      }

      if (data.success) {
        // Update formData with new API key
        setFormData((prev) => ({
          ...prev,
          data: { ...prev.data, apiKey: data.apiKey },
        }));
        // Update dataCache
        const updatedAgents = dataCache.agents.map((agent) =>
          agent.id === formData.data.id
            ? { ...agent, apiKey: data.apiKey }
            : agent
        );
        const updatedAgentsLookup = {
          ...dataCache.agentsLookup,
          [formData.data.id]: {
            ...dataCache.agentsLookup[formData.data.id],
            apiKey: data.apiKey,
          },
        };
        setDataCache({
          ...dataCache,
          agents: updatedAgents,
          agentsLookup: updatedAgentsLookup,
        });
        // Refresh UI
        setTimeout(() => {
          refreshDetails();
        }, 1000);
      } else {
        alert(data.message || "Failed to generate API key");
      }
    } catch (error) {
      console.error("API key generation failed:", error);
      alert(`API key generation failed: ${error.message}`);
    } finally {
      setIsLoadingApiKey(false); // Reset loading state
    }
  };

  const uploadAttachment = () => {
    props.setDisplayState("UPLOAD_ATTACHMENT");
    props.setActionType("UPLOAD_ATTACHMENT");
  };

  const scanWebsite = async () => {
    alert(
      "Scanning " + formData.data["website"] + " and building search index"
    );
    setScanning(true);
    console.log("in scanWebsite");
    const response = await fetchSecure(
      "api/scanWebsite/" +
        encodeURIComponent(formData.data["website"]) +
        "/" +
        formData.data["id"] +
        "/" +
        props.user
    );
    console.log(response);
    const data = await response.json();
    console.log(data);
    //if (globalData.debug)
    console.log("Result from scan = " + JSON.stringify(data));
    if ("status" in data && data.status === "failed")
      alert("Website scanning failed: " + data.error);
    if ("status" in data && data.status === "success") {
      alert("Website scanning failed: " + data.error);
      refreshDetails();
    }
    setScanning(false);
  };

  //const refreshDetails = (props) => {
  /* KAD removed props since we can pick that up from the scope JAN 29, 2025 */
  /* KAD added check for thisObject on Feb 11, 2025 REMOVE IF THINGS BREAK */
  const refreshDetails = () => {
    /*
    if (props.thisObject) {
    } else {
    }
*/
    props.loadObject(formData.data["id"]);
    setRefreshKey((prev) => prev + 1); // Increment refreshKey
    setTimeout(() => {
      props.setDisplayState("X");
      props.setDisplayState("DISPLAY");
    }, 1000);
  };

  /* Vik(May 19, 2025): Function to provide required to buttons on ui */
  const getButtons = () => {
    const buttons = [];

    // Back button
    if (canGoBack(props)) {
      buttons.push(
        <SuperAppButton
          key="back"
          className="primary-gradient-btn"
          onClick={(e) => back(props)}
          style={{ padding: "4px 16px", fontSize: "14px" }}
        >
          Back
        </SuperAppButton>
      );
    }

    // Edit button
    if (canEdit(props, props.config, formData.data)) {
      buttons.push(
        <SuperAppButton
          key="edit"
          className="primary-gradient-btn"
          onClick={(e) => editRecord()}
          style={{ padding: "4px 16px", fontSize: "14px" }}
        >
          Edit
        </SuperAppButton>
      );
    }

    // Delete button
    if (canDeleteRow(props, props.config, formData.data)) {
      buttons.push(
        <SuperAppButton
          key="delete"
          className="primary-gradient-btn"
          onClick={(e) =>
            window.confirm("Are you sure you wish to delete this object?") &&
            handleDelete()
          }
          style={{ padding: "4px 16px", fontSize: "14px" }}
        >
          Delete
        </SuperAppButton>
      );
    }

    // Refresh button
    if (props.depth === 1 && canRefresh(props)) {
      buttons.push(
        <SuperAppButton
          key="refresh"
          className="primary-gradient-btn"
          onClick={(e) => refreshDetails()}
          style={{ padding: "4px 16px", fontSize: "14px" }}
        >
          Refresh
        </SuperAppButton>
      );
    }

    // Upload Files button
    if (canUploadFiles(props)) {
      buttons.push(
        <SuperAppButton
          key="upload"
          className="primary-gradient-btn"
          onClick={(e) => uploadAttachment()}
          style={{ padding: "4px 16px", fontSize: "14px" }}
        >
          Upload Files(s)
        </SuperAppButton>
      );
    }

    // Clone button
    if (
      canDeleteRow(props, props.config, formData.data) &&
      canClone(props, props.config, formData.data)
    ) {
      buttons.push(
        <SuperAppButton
          key="clone"
          className="primary-gradient-btn"
          onClick={(e) =>
            window.confirm("Are you sure you wish to clone this object?") &&
            handleClone()
          }
          style={{ padding: "4px 16px", fontSize: "14px" }}
        >
          Clone
        </SuperAppButton>
      );
    }

    // Reindex button
    if (
      isSystemAdmin() &&
      ["DOCUMENT_QA", "WEBSITE_QA", "COMBINATION_AGENT"].includes(
        props.thisObject.agentType
      )
    ) {
      buttons.push(
        <SuperAppButton
          key="reindex"
          className="primary-gradient-btn"
          onClick={(e) =>
            window.confirm("Are you sure you wish to re-index this object?") &&
            handleReIndex()
          }
          disabled={isReindexing}
          style={{ padding: "4px 16px", fontSize: "14px" }}
        >
          Reindex
          {isReindexing && <Spinner animation="border" size="sm" />}
        </SuperAppButton>
      );
    }

    // Comment button
    if (
      "flags" in props.config &&
      props.config.flags.indexOf("comments") >= 0
    ) {
      buttons.push(
        <SuperAppButton
          key="comment"
          className="primary-gradient-btn"
          onClick={(e) => addCommentPopup(e)}
          style={{ padding: "4px 16px", fontSize: "14px" }}
        >
          Comment
        </SuperAppButton>
      );
    }

    /* TODO/KADFIX, remove this code shortly when we know dynamicButtons is working */
    if (
      false &&
      "website" in formData.data &&
      formData.data["agentType"] === "WEBSITE_QA" &&
      formData.data["website"].length > 0
    ) {
      buttons.push(
        <SuperAppButton
          className="primary-gradient-btn"
          disabled={scanning}
          onClick={(e) => scanWebsite()}
        >
          Scan Website{"  "}
          {scanning && <Spinner animation="border" size="sm" />}
        </SuperAppButton>
      );
    }

    // Generate API Key button
    if (isSystemAdmin() && props.config.collection === "agents") {
      buttons.push(
        <SuperAppButton
          key="generateApiKey"
          className={`primary-gradient-btn ${
            isLoadingApiKey ? "disabled-btn" : ""
          }`}
          onClick={(e) =>
            !isLoadingApiKey &&
            window.confirm(
              `Are you sure you wish to ${
                formData.data.apiKey ? "re-generate a new" : "generate an"
              } API key for this agent?`
            ) &&
            handleGenerateApiKey()
          }
          disabled={isLoadingApiKey}
          style={{ padding: "4px 16px", fontSize: "14px" }}
        >
          {isLoadingApiKey
            ? "Generating..."
            : formData.data.apiKey
            ? "Regenerate API Key"
            : "Generate API Key"}
        </SuperAppButton>
      );
    }

    // Dynamic display buttons
    if (props.dynamicDisplayButtons) {
      props.dynamicDisplayButtons.forEach((button, index) => {
        buttons.push(
          <button.component
            key={`dynamic-${index}`}
            user={props.user}
            userDeep={props.userDeep}
            data={formData.data}
            refreshDetails={refreshDetails}
            _key={button._key}
            label={button.label}
            isDocumentEqual={
              isDocumentEqual
            } /* Vik(Jun 27, 2025): Pass isDocumentEqual to dynamic buttons for PublishAgent */
          />
        );
      });
    }

    return buttons;
  };

  const actionButtons = getButtons();

  /*Vik(Aug 27, 2025): Getting buttons from dynamicDisplayButtons of agents */
  let firstRowButtons = [];
  let secondRowButtons = [];

  if (props.config.collection === "agents") {
    const filteredButtons = props.dynamicDisplayButtons.filter((button) => {
      // Check if the button should be visible based on its component and conditions
      if (button.component.name === "ScanWebsite") {
        return (
          props.thisObject?.website &&
          ["WEBSITE_QA", "COMBINATION_AGENT"].includes(
            props.thisObject?.agentType
          ) &&
          props.thisObject.website.length > 0
        );
      } else if (button.component.name === "UploadFilesButton") {
        return (
          props.config?.flags?.includes("attachments") &&
          [
            "DOCUMENT_QA",
            "FAQ",
            "COMBINATION_AGENT",
            "ANALYTICS_AGENT",
          ].includes(props.thisObject?.agentType)
        );
      } else if (button.component.name === "EditButton") {
        return canEdit(props, props.config, props.thisObject);
      } else if (button.component.name === "DeleteButton") {
        return canDeleteRow(props, props.config, props.thisObject);
      } else if (button.component.name === "RefreshButton") {
        return canRefresh(props);
      } else if (button.component.name === "BackButton") {
        return canGoBack(props);
      } else if (button.component.name === "CommentButton") {
        return props.config?.flags?.includes("comments");
      } else if (button.component.name === "PublishAgent") {
        const isSystemAdmin = () =>
          props.userDeep?.roles?.toLowerCase().indexOf("system_admin") >= 0;
        //return isSystemAdmin() && !props.isDocumentEqual;
        return !props.isDocumentEqual; /* KAD changed Sept 23, 2025 to show for everyone */
      } else if (button.component.name === "ReindexButton") {
        return (
          isSystemAdmin() &&
          ["DOCUMENT_QA", "WEBSITE_QA", "COMBINATION_AGENT"].includes(
            props.thisObject.agentType
          )
        );
      } else {
        // For custom or other buttons, assume they should be shown unless specific logic is added
        return true;
      }
    });

    // Split buttons into first and second rows based on row property
    firstRowButtons = filteredButtons
      .filter((button) => button.row === "first")
      .map((button, index) => (
        <div key={button._key} className="action-button">
          <button.component
            label={
              typeof button.label === "function"
                ? button.label(props.thisObject)
                : button.label
            }
            user={props.user}
            userDeep={props.userDeep}
            data={props.thisObject}
            config={props.config}
            setDisplayState={props.setDisplayState}
            setActionType={props.setActionType}
            loadObjects={props.loadObjects}
            loadObject={props.loadObject}
            setActiveTab={props.setActiveTab}
            activeTab={activeTab}
            setRefreshKey={setRefreshKey}
            setShowAddComment={setShowAddComment}
            showAddComment={showAddComment}
            setFormData={setFormData}
            refreshDetails={refreshDetails}
            isDocumentEqual={isDocumentEqual}
            dontPersistData={props.dontPersistData}
            hideBackButton={props.hideBackButton}
            showSpinner={button.showSpinner}
          />
        </div>
      ));

    secondRowButtons = filteredButtons
      .filter((button) => button.row !== "first") // Default to second row if row is undefined or not "first"
      .map((button, index) => (
        <div key={button._key} className="action-button">
          <button.component
            label={
              typeof button.label === "function"
                ? button.label(props.thisObject)
                : button.label
            }
            user={props.user}
            userDeep={props.userDeep}
            data={props.thisObject}
            config={props.config}
            setDisplayState={props.setDisplayState}
            setActionType={props.setActionType}
            loadObjects={props.loadObjects}
            loadObject={props.loadObject}
            setActiveTab={props.setActiveTab}
            activeTab={activeTab}
            setRefreshKey={setRefreshKey}
            setShowAddComment={setShowAddComment}
            showAddComment={showAddComment}
            setFormData={setFormData}
            refreshDetails={refreshDetails}
            isDocumentEqual={isDocumentEqual}
            dontPersistData={props.dontPersistData}
            hideBackButton={props.hideBackButton}
            showSpinner={button.showSpinner}
          />
        </div>
      ));
  }

  const addCommentPopup = (e) => {
    setShowAddComment(true);
  };

  const addComment = async (e) => {
    e.preventDefault();
    const dataToSave = {
      object: props.config.collection,
      id: formData.data["id"],
      comment: comment,
      userId: props.user,
    };
    const response = await fetchSecure("/api/addTracking", {
      headers: { "Content-Type": "application/json" },
      method: "post",
      body: JSON.stringify(dataToSave),
    });
    const data = await response.json();
    setShowAddComment(false);
    setTimeout(refreshDetails(), 2000);
  };
  // const reformatFieldWithNewLines = (fieldWithNewLines) => {
  //   var strArray = fieldWithNewLines.split("\n");
  //   const finalArray = [];
  //   // eslint-disable-next-line no-lone-blocks
  //   {
  //     strArray.map((str) => {
  //       finalArray.push(<div>{str}</div>);
  //       return true;
  //     });
  //   }
  //   return finalArray;
  // };

  const reformatFieldWithNewLines = (fieldWithNewLines) => {
    const strArray = (fieldWithNewLines || "").split("\n");
    return strArray.map((str, idx) => <div key={idx}>{str}</div>);
  };

  // returns true if a value is "present" (non-empty string/array/object, or any number/boolean)
  const isPopulated = (v) => {
    if (v === undefined || v === null) return false;
    if (typeof v === "string") return v.trim().length > 0;
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === "object") return Object.keys(v).length > 0;
    return true; // numbers, booleans, etc.
  };

  // supports show_if_populated on the same field (true), a single other field (string), or an array of fields
  const passesShowIfPopulated = (row, dataObj) => {
    const sip = row?.show_if_populated;
    if (!sip) return true; // nothing to enforce

    if (sip === true) return isPopulated(dataObj?.[row.name]);
    if (typeof sip === "string") return isPopulated(dataObj?.[sip]);
    if (Array.isArray(sip)) return sip.some((k) => isPopulated(dataObj?.[k]));

    return true; // fallback: don't hide
  };

  function formatDropdownDisplayTemplate(template, options) {
    return template.replace(/\[([^\]]+)\]/g, (match, key) => {
      return options?.[key] || match;
    });
  }

  function drawListDisplay(fieldConfig, key, item, fieldData) {
    if (typeof fieldConfig.list_subtable === "undefined") {
      if (fieldConfig.list_fields.length === 0) {
        return <>{item} </>;
      } else {
        var value = item[key];
        if (typeof value === "boolean") value = value + "";

        return <>{value}</>;
      }
    } else {
      const cachedObject =
        dataCache?.[fieldConfig?.list_subtable + "Lookup"]?.[item?.[key]];
      for (let x = 0; x < fieldConfig.list_config.length; x++) {
        const field = fieldConfig.list_config[x];
        var displayTemplate = formatDropdownDisplayTemplate(
          field.dropdown_display_template,
          cachedObject
        );
        if (displayTemplate === field.dropdown_display_template) {
          displayTemplate = fieldData;
        }
        return <>{displayTemplate}</>;
      }
    }
  }

  const showField = (field, formData) => {
    //console.log("🚀 ~ showField ~ field:", field);
    /* TODO: KAD keep an eye on this to see if it screws up other stuff */
    /* clean up numbers fields and make strings for better downstream processing */
    // if (
    //   field.name in formData.data &&
    //   typeof formData.data[field.name] === "number"
    // )
    //   formData.data[field.name] = formData.data[field.name] + "";

    // var fieldData = formData.data[field.name] || "";

    let fieldData = formData.data?.[field.name] ?? "";
    if (typeof fieldData === "number") {
      fieldData = String(fieldData); // don't mutate formData.data
    }

    /* TODO : Need to find a better way to read BQ timestamp formats..that is 100% why this one if statement is here */
    if (typeof fieldData === "object" && "value" in fieldData) {
      fieldData = fieldData["value"];
    }
    if (field.input_type === "textarealist") {
      return (
        <div
          key={field.name}
          style={{ width: "100%" }}
          // className="form-group"
        >
          <TextareaList
            config={{ ...field, ...field?.config }}
            title={field?.display_name}
            targetValue={field?.targetValue}
            value={formData?.data[field?.name]}
            onChange={(data) => {
              // KAD took out to clean log Sept 30, 2025 ..assume software is working at this point console.log("🚀 ~ TextareaListdata:", data);
              // setListData(field.name, data);
            }}
            dataObject={formData?.data}
            selectedList={formData?.data[field?.name] || []}
            isDisable={true}
          />
        </div>
      );
    }
    if (field.input_type === "object") {
      const formattedJson = JSON.stringify(fieldData, null, " ");
      return (
        <pre style={{ color: "rgb(169, 169, 169)" }}>
          <code>{formattedJson}</code>
        </pre>
      );
    }
    if (field.input_type === "empty") {
      return <div></div>;
    }

    if (field.input_type === "multiselect") {
      /* KAD added Sept 30, 2025 to improve formatting */
      let finalString = fieldData.map((item) => capitalize(item)).join(", ");
      return finalString;
    }

    if (field.input_type === "list") {
      let finalArray = [];
      let finalString = "";

      /*(Vik: Aug 7, 2025): Handle subAgents and integrations specifically*/
      if (field.name === "subAgents" || field.name === "integrations") {
        if (Array.isArray(fieldData)) {
          const lookupKey =
            field.name === "subAgents" ? "agentsLookup" : "integrationsLookup";
          const displayField =
            field.list_display_field ||
            (field.name === "subAgents" ? "agentName" : "name");
          const ids = fieldData.map((item) => item.id || item);

          // Create table-compatible data
          const tableData = ids.map((id) => {
            const lookupEntry = dataCache?.[lookupKey]?.[id];
            if (!lookupEntry) {
              console.warn(
                `No lookup entry found for ID: ${id} in ${lookupKey}`
              );
              return { id, [displayField]: id }; // Fallback to ID
            }
            const name = lookupEntry[displayField] || id;
            return { id, [displayField]: name }; // Structure for table
          });

          // For table display, use renderTable
          if (field.list_display === "table") {
            finalArray.push(
              renderTable({
                data: tableData,
                headers: [displayField], // Use displayField instead of list_fields
                config: {
                  listConfig: field.list_config,
                  list_subtable: field.list_subtable,
                  dataCache,
                },
                isListComponent: false,
                callbacks: {},
                expandedCells,
                toggleExpandCell,
                showAllRows,
                setShowAllRows,
                maxRows: 3,
                style: {
                  container: { marginTop: "10px" },
                },
              })
            );
          } else {
            // Fallback to string for non-table displays
            finalString = tableData
              .map((item) => item[displayField])
              .filter((name) => name !== undefined && name !== null)
              .join(", ");
          }
        } else {
          console.warn(
            `fieldData is not an array for ${field.name}:`,
            fieldData
          );
          finalString = fieldData || "Not Specified";
        }
      } else if (field.list_fields) {
        if (Array.isArray(fieldData)) {
          if (field.list_display === "table") {
            finalArray.push(
              renderTable({
                data: fieldData,
                headers: field.list_fields,
                config: {
                  listConfig: field.list_config,
                  list_subtable: field.list_subtable,
                  dataCache,
                },
                isListComponent: false,
                callbacks: {},
                expandedCells,
                toggleExpandCell,
                showAllRows,
                setShowAllRows,
                maxRows: 3,
                style: {
                  container: { marginTop: "10px" },
                },
              })
            );
          }

          // **Case: "horizontal" display** Vik, Feb 6, 2025
          else if (field.list_display === "horizontal") {
            const fieldHeaders = field.list_fields.join(", ");
            finalArray.push(
              <div key="header">
                <strong>{fieldHeaders}</strong>
              </div>
            );

            fieldData.forEach((item) => {
              const fieldValues = field.list_fields
                .map((fieldKey) => item[fieldKey])
                .join(", ");
              finalArray.push(<div key={item.id}>{fieldValues}</div>);
            });
          }

          // **Case: "vertical" display** Vik, Feb 6, 2025
          else if (field.list_display === "vertical") {
            fieldData.forEach((item, index) => {
              finalArray.push(
                <div key={index} style={{ marginBottom: "10px" }}>
                  {field.list_fields.map((fieldKey) => (
                    <div key={fieldKey}>
                      <strong>{fieldKey}:</strong> {item[fieldKey]}
                    </div>
                  ))}
                </div>
              );
            });
          }

          // **Plain Text Rendering (when list_display is undefined)** Vik, Feb 6, 2025
          else {
            finalString = fieldData
              .map((item) => item[field.list_fields[0]])
              .join(", ");
          }
        }
      } else {
        // **For Simple Arrays (field.list_fields is undefined)** Vik, Feb 6, 2025
        if (Array.isArray(fieldData)) {
          if (
            ["horizontal", "vertical", "table"]?.includes(field.list_display)
          ) {
            fieldData.forEach((str, index) => {
              finalArray.push(<div key={index}>{str}</div>);
            });
          } else {
            finalString = fieldData.join(", ");
          }
        }
      }

      // **Final Return Conditions** Vik, Feb 6, 2025
      if (finalArray.length === 0 && finalString.length === 0) {
        return "Not specified";
      } else if (finalArray.length > 0) {
        return finalArray;
      } else {
        return finalString;
      }
    }
    if (
      field.input_type === "dynamicJsonEditorV1" ||
      field?.input_type === "dynamicJsonEditorV2"
    ) {
      const formattedJson = JSON.stringify(fieldData, null, 2);

      let uiType = formData?.data?.response_object?.display_type;
      let parameters = formData?.data?.response_object?.parameters;

      let parentCss = parameters?.[0]?.parentCss || {};

      return (
        // <pre style={{ color: "rgb(169, 169, 169)" }}>
        //   <code>{formattedJson}</code>
        // </pre>

        <div
          style={{
            width: "250px",
            // height: "400px",
            overflow: "auto",
            borderRadius: "10px",
          }}
        >
          {uiType !== "Itinerary" ? (
            <div style={{ ...parentCss }}>
              <CardPreview blocks={parameters} />
            </div>
          ) : (
            <ItineraryWidget blocks={parameters} />
          )}
        </div>
      );
    }
    if (field.input_type === "dropdown") {
      /* TODO: can't be hardcoded in the generic SuperAppObject */
      if (
        (field.values === "myObjects" || field.values === "agents") &&
        props.allObjects
      ) {
        for (let x = 0; x < props.allObjects.length; x++) {
          if (props.allObjects[x]["id"] === fieldData) {
            return (
              <>
                {props?.allObjects?.[x]?.["agentName"]} -{" "}
                {props?.allObjects?.[x]?.["agentType"]}
              </>
            );
          }
        }
      }

      //if (typeof field.dropdown_display_template !== "undefined" && typeof field.values === 'string')
      else if (typeof field.dropdown_display_template !== "undefined") {
        //console.log(JSON.stringify(field));
        const values = field.values.split(".");
        if (values[0] === "adminConfig") {
          const agentTypes = myContext["data"][values[1]];
          //console.log(agentTypes);
          if (agentTypes) {
            /* KAD Added Mar 3, 2025 because agentTypes wasn't populated for some reason */
            for (let x = 0; x < agentTypes.length; x++) {
              if (agentTypes[x][field.dropdown_value_key] === fieldData) {
                const options = agentTypes[x];
                //console.log("options " + JSON.stringify(options));
                var displayTemplate = formatDropdownDisplayTemplate(
                  field.dropdown_display_template,
                  options
                );
                if (displayTemplate === field.dropdown_display_template) {
                  displayTemplate = fieldData;
                }
                return <>{displayTemplate}</>;
              }
            }
          }
        }
      } else if (
        Array.isArray(field.values) &&
        Array.isArray(field.values_display_names)
      ) {
        /* KAD added this Jan 14, 2025 to allow a new config field values_display_names to be used */
        var done = false;
        for (let x = 0; x < field.values.length && !done; x++) {
          if (field.values[x] === fieldData) {
            done = true;
            return <>{field.values_display_names[x]}</>;
          }
        }
      }
      if (fieldData.length > 0) return <>{fieldData}</>;
      else return <>Not Specified</>;
    }

    if (field.input_type === "checkbox") {
      return <>{fieldData ? capitalize(fieldData + "") : "False"}</>;
    }

    // console.log("🚀 ~ showField ~ fieldData:", fieldData);
    if (
      field.input_type === "text" &&
      fieldData &&
      typeof fieldData ===
        "string" /* Vik (Jan 20, 2026): Added check to prevent crash if fieldData is not a string */ &&
      (fieldData.toLowerCase().endsWith(".png") ||
        fieldData.toLowerCase().endsWith(".gif") ||
        fieldData.toLowerCase().endsWith(".jpeg") ||
        fieldData.toLowerCase().endsWith(".jpg") ||
        fieldData.toLowerCase().endsWith(".webp") ||
        fieldData.toLowerCase().endsWith(".svg"))
    )
      return (
        <>
          <SecureImage
            url={fieldData}
            imageData={{
              width: field?.image_width,
              height: field?.image_height,
            }}
          />
        </>
      );
    if (field.input_type === "text" && field?.name === "agentIcon")
      return (
        <>
          <SecureImage
            url={fieldData}
            imageData={formData?.data?.agent_icon_configuration}
          />
        </>
      );
    if (field.input_type === "mcp_client") {
      return (
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            overflow: "auto",
          }}
        >
          <MCPClientUI />
        </div>
      );
    }
    if (field.input_type === "multiHtmlContent") {
      return (
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            overflow: "auto",
          }}
        >
          {/*console.log("fieldfield", formData)*/}
          <MultiHtmlContent
            contentObject={formData?.data?.[field?.name]}
            isDisable={true}
          />
        </div>
      );
    }

    /* TODO: Too much hardcoded stuff here...need more refactoring */
    /* this is for fields that have links which need us to search and replace before showing */

    if (typeof field.display_template !== "undefined") {
      let str = field.display_template
        .replace("[" + field.name + "]", fieldData)
        .replaceAll("[agentURL]", myContext["data"]["agentURL"])
        // (MK) Updating with new code for svg implementation
        // .replace(
        //   "[agentIcon]",
        //   "agentIcon" in formData.data
        //     ? formData.data["agentIcon"]
        //     : "https://upload.wikimedia.org/wikipedia/commons/8/85/Circle-icons-chat.svg"
        // ) /* cleaned up this code on Jan 15, 2025 */
        /* KAD added this Sept 14, 2025 */
        .replaceAll(
          "[publishedAgentId]",
          "publishedAgentId" in formData.data &&
            formData.data["publishedAgentId"].length > 0
            ? formData.data["publishedAgentId"]
            : "PUBLISH YOUR AGENT;"
        )
        .replaceAll(
          "[iconLocation]",
          "iconLocation" in formData.data &&
            formData.data["iconLocation"].length > 0
            ? formData.data["iconLocation"]
            : "bottom 48px;"
        )
        .replace(
          "[customerId]",
          "customerId" in formData.data &&
            formData.data["customerId"].length > 0
            ? formData.data["customerId"]
            : "WWWW"
        )
        .replace(
          "[popupText]",
          "popupText" in formData.data && formData.data["popupText"].length > 0
            ? formData.data["popupText"]
            : "Hey There. Is there anything we can help you with? Click on my chat icon and we can talk about your interests in our company and products."
        )
        .replace(
          "[popupDelay]",
          "popupDelay" in formData.data &&
            formData.data["popupDelay"].length > 0
            ? formData.data["popupDelay"]
            : "5"
        )
        .replace(
          "[borderWidth]",
          "borderWidth" in formData.data &&
            formData.data["borderWidth"].length > 0
            ? formData.data["borderWidth"]
            : "0"
        )

        // New replacements for configurable sizes
        .replaceAll(
          "[chatIconWidth]",
          "chatIconWidth" in formData.data &&
            formData.data["chatIconWidth"].length > 0
            ? formData.data["chatIconWidth"]
            : "40px"
        )
        .replaceAll(
          "[chatIconHeight]",
          "chatIconHeight" in formData.data &&
            formData.data["chatIconHeight"].length > 0
            ? formData.data["chatIconHeight"]
            : "40px"
        )
        .replaceAll(
          "[modalMaxWidth]",
          "modalMaxWidth" in formData.data &&
            formData.data["modalMaxWidth"].length > 0
            ? formData.data["modalMaxWidth"]
            : "200px"
        )

        // New replacements for chatCloseBtn
        .replaceAll(
          "[chatCloseBtnWidth]",
          "chatCloseBtnWidth" in formData.data &&
            formData.data["chatCloseBtnWidth"].length > 0
            ? formData.data["chatCloseBtnWidth"]
            : "20px"
        )
        .replaceAll(
          "[chatCloseBtnHeight]",
          "chatCloseBtnHeight" in formData.data &&
            formData.data["chatCloseBtnHeight"].length > 0
            ? formData.data["chatCloseBtnHeight"]
            : "20px"
        )
        .replaceAll(
          "[chatCloseBtnTop]",
          "chatCloseBtnTop" in formData.data &&
            formData.data["chatCloseBtnTop"].length > 0
            ? formData.data["chatCloseBtnTop"]
            : "5px"
        )
        .replaceAll(
          "[chatCloseBtnRight]",
          "chatCloseBtnRight" in formData.data &&
            formData.data["chatCloseBtnRight"].length > 0
            ? formData.data["chatCloseBtnRight"]
            : "5px"
        )
        .replaceAll(
          "[popupGap]",
          "popupGap" in formData.data && formData.data["popupGap"].length > 0
            ? formData.data["popupGap"]
            : "10px"
        )
        .replaceAll("[envName]", envName || "dev");
      // (MK) Updating with new code for svg implementation
      if (formData.data?.["agentIcon"]) {
        let icon = formData.data?.["agentIcon"];
        if (icon.startsWith("http")) {
          str = str.replaceAll(
            "[agentIcon]",
            "agentIcon" in formData.data
              ? icon
              : "https://upload.wikimedia.org/wikipedia/commons/8/85/Circle-icons-chat.svg"
          ); /* cleaned up this code on Jan 15, 2025 */
        } else {
          // console.log("🚀 ~ showField ~ formData:", formData);
          let iconData = formData?.data?.agent_icon_configuration;
          let iconTag = `<img id="chatIcon" src='[agentIcon]' height='40px' width='40px'></img>`;
          if (iconData && typeof iconData === "object") {
            let {
              color = "#000000",
              secondaryColor = "#FFFFFF",
              height = "40px",
              width = "40px",
            } = iconData;
            str = str.replace(
              iconTag,
              IconsDetails(color, secondaryColor, height, width, icon)
                .embeddedIcon
            );
          } else {
            /* Vik(May 13, 2025): Fallback to default icon if agent_icon_configuration is undefined */
            str = str.replaceAll(
              "[agentIcon]",
              "https://upload.wikimedia.org/wikipedia/commons/8/85/Circle-icons-chat.svg"
            );
          }
        }
      }
      //  <img src='[agentIcon]' height='40px', width='40px'></img>
      var result = [];
      if (field.show_copy_button) {
        result.push(
          <div style={props.style.copyButton}>
            <SuperAppButton onClick={() => handleCopyClick(str)}>
              Copy
            </SuperAppButton>
          </div>
        );
      }

      result = result.concat(reformatFieldWithNewLines(str));
      if (field.display_x_rows) {
        result = result.slice(0, field.display_x_rows);
      }
      return result;
    } else if (typeof field.link !== "undefined") {
      return (
        <a
          href={field.link
            .replace("[" + field.name + "]", fieldData)
            .replace("[agentURL]", myContext["data"]["agentURL"])
            .replace(
              "[customerId]",
              "customerId" in myContext["data"]
                ? myContext["data"]["customerId"]
                : "WWWW"
            )}
          target="_blank"
          rel="noopener noreferrer"
        >
          {fieldData}
        </a>
      );
    } else if (field.flags && field.flags.indexOf("href") >= 0) {
      return (
        <a href={fieldData} target="_blank" rel="noopener noreferrer">
          Link
        </a>
      );
    } else if (
      field.input_type === "textarea" &&
      fieldData.length > 0 &&
      fieldData.indexOf("\n") >= 0
    ) {
      /* this is higher priority */
      if (field.display_as_html) {
        return <div dangerouslySetInnerHTML={{ __html: fieldData }}></div>;
      } else {
        var displayString = reformatFieldWithNewLines(fieldData);
        if (field.display_x_rows) {
          displayString = displayString.slice(0, field.display_x_rows);
        }
        return displayString;
      }
    } else if (
      field.name in formData.data &&
      typeof formData.data[field.name] === "boolean"
    ) {
      /* had to do some crazy logic here for Booleans == to false */
      const displayString = formData.data[field.name] + "";
      return <>{capitalize(displayString)}</>;
    } else if (fieldData && fieldData.length > 0) {
      if (field.input_type === "color") {
        const style = {
          backgroundColor: fieldData,
        };
        return (
          <>
            {fieldData} <div style={style}>  </div>
          </>
        );
      } else if (field.flags && field.flags.indexOf("date") >= 0)
        return <>{fieldData.substring(0, 10)}</>;
      else if (fieldData === true || fieldData === false)
        return <>{capitalize(fieldData)}</>;
      else return <>{JSON.stringify(fieldData)}</>;
    } else {
      return <>Not Specified</>;
    }
  };
  const handleLike = async () => {
    if (globalData.debug) console.log("LIKE clicked");
    if (!("Likes" in formData.data)) formData.data["Likes"] = [];
    formData.data["NumLikes"] = 0;

    if (!formData.data["Likes"]?.includes(props.user)) {
      formData.data["Likes"].push(props.user);
      formData.data["NumLikes"] = formData.data["Likes"].length;
    } else {
      var done = false;
      for (var x = 0; x < formData.data["Likes"].length && !done; x++) {
        if (formData.data["Likes"][x] === props.user) {
          formData.data["Likes"].splice(x, 1);
          formData.data["NumLikes"] = formData.data["Likes"].length;
          done = true;
        }
      }
    }
    const response = await fetchSecure(
      "/api/saveObject/" + props.config.collection,
      {
        headers: { "Content-Type": "application/json" },
        method: "post",
        body: JSON.stringify(formData.data),
      }
    );
    await response.json();
    setFormData({
      ...formData,
      status: "IDLE",
    });
  };

  function isSystemAdmin() {
    if (
      props.userDeep &&
      props.userDeep.roles &&
      props.userDeep.roles.toLowerCase().indexOf("system_admin") >= 0
    )
      return true;
    return false;
  }

  const isDocumentChanged = async () => {
    if (!formData.data.publishedAgentId) {
      setIsDocumentEqual(false);
      return true;
    }
    try {
      const data = {
        collection1: "agents",
        id1: formData.data.id,
        collection2: "agents",
        id2: formData.data.publishedAgentId,
      };
      let response = await fetchSecure("/api/compareDocuments", {
        headers: { "Content-Type": "application/json" },
        method: "post",
        body: JSON.stringify(data),
      });
      let result = await response.json(); // Await the JSON parsing
      if (result.success) {
        if (result.isEqual) {
          setIsDocumentEqual(result.isEqual);
        } else {
          setIsDocumentEqual(false);
        }
      }
    } catch (error) {
      console.error("Error in isDocumentChanged:", error);
      return { isEqual: false, mismatchedKeys: [], error: error.message };
    }
  };

  useEffect(() => {
    setDisplayArray(props.config.fields);
    isDocumentChanged();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* TODO KAD try this take out if not doing anything ..I was changing the thisObject and screen wasn't redrawing Oct 6, 2024 */
  useEffect(() => {
    //console.log("PROPS DATA = " + JSON.stringify(props.thisObject));
    setFormData({
      data: props.thisObject,
      status: "IDLE",
    });
  }, [props.thisObject]);

  const menumap = {};
  let lastHeaderIdx = -1;
  displayArray.forEach((row, index) => {
    if ("header" in row) lastHeaderIdx = index;
    if (lastHeaderIdx >= 0) menumap[lastHeaderIdx] = index;
  });

  return (
    <Container className="sec-all-text-white">
      <Row>
        <Col>
          <TopMargin />
          <Row>
            {/* Action Buttons */}
            {isMobile ? (
              <ActionAccordionMobile
                firstRowButtons={
                  props.config.collection === "agents"
                    ? firstRowButtons
                    : actionButtons
                }
                secondRowButtons={
                  props.config.collection === "agents" ? secondRowButtons : []
                }
                style={{
                  ...props.style,
                  buttonContainer: { padding: "0", margin: "0", width: "100%" },
                }}
              />
            ) : (
              <ActionAccordionDesktop
                firstRowButtons={
                  props.config.collection === "agents"
                    ? firstRowButtons
                    : actionButtons
                }
                secondRowButtons={
                  props.config.collection === "agents" ? secondRowButtons : []
                }
                style={{
                  ...props.style,
                  buttonContainer: { padding: "0", margin: "0", width: "100%" },
                }}
              />
            )}

            {/* Tab Navigation */}
            {tabs.length > 1 && (
              <div className="superappobject">
                <div className="top-menu">
                  <div style={{ padding: "0px" }}>
                    <ul
                      className="menu-lists"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        padding: "0",
                        margin: "0",
                        listStyle: "none",
                      }}
                    >
                      {tabs.map((tab, index) => (
                        <li
                          className="menu-item"
                          key={index}
                          style={{
                            flex: "1 0 auto",
                            minWidth: "50px",
                            paddingRight: "10px",
                          }}
                        >
                          <button
                            onClick={() => setActiveTab(index)}
                            className={activeTab === index ? "active" : ""}
                          >
                            {tab.title}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
            <Modal
              show={showAddComment}
              onHide={() => setShowAddComment(false)}
              className="theme-modal-s1 w600px"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Enter Your Comment</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Form onSubmit={(e) => addComment(e)}>
                  <Form.Group
                    controlId="formBasicResetEmail"
                    className="form-group"
                  >
                    <label>Comment</label>
                    <Form.Control
                      as="textarea"
                      type="textarea"
                      rows="5"
                      placeholder="Enter Your Comment"
                      onChange={(e) => setComment(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <div className="form-submit-group">
                    <SuperAppButton
                      className="primary-gradient-btn submit-btn w-100"
                      type="submit"
                    >
                      Save Comment
                    </SuperAppButton>
                  </div>
                </Form>
              </Modal.Body>
            </Modal>
            <div style={{ textAlign: "right", width: 10 + "%" }}>
              {props.config && props.config.showLikes && (
                <SuperAppButton onClick={handleLike}>
                  {"Likes" in formData.data &&
                    formData.data.Likes?.includes(props.user) && (
                      <div className="text-link-white-btn">Liked:</div>
                    )}
                  {"Likes" in formData.data &&
                    !formData.data.Likes?.includes(props.user) && (
                      <img src={likeImage} width="20px" alt={"Like"} />
                    )}
                  {!("Likes" in formData.data) && (
                    <img src={likeImage} width="20px" alt={"Like"} />
                  )}
                  {"Likes" in formData.data &&
                    formData.data.Likes.length > 0 && (
                      <div>{formData.data.Likes.length}</div>
                    )}
                </SuperAppButton>
              )}
            </div>
          </Row>

          <RowMargin />
          <div key={`tab-body-${activeTab}`}>
            {formData &&
              tabs.length > 0 &&
              tabs[activeTab] &&
              tabs[activeTab].rows.map((row, rowIndex) => (
                <div className="row" key={`row-${activeTab}-${rowIndex}`}>
                  {" "}
                  {/* Key for each row */}
                  {row.map((row, i) => {
                    /* show some fields only if condition is satisfied */
                    if (typeof row.conditional !== "undefined") {
                      // ONLY SUPPORT == now...must be space delimited
                      if (false) {
                        const values = row.conditional.split(" ");
                        if (formData.data[values[0]] !== values[2])
                          return <></>;
                      } else {
                        /* KAD added April 8, 2025 */
                        if (!evaluateCondition(row, formData)) {
                          return <></>; // Or null, or whatever you want to return
                        }
                      }
                    }
                    /* CONDITIONAL LOGIC IS APPLIED TO DISPLAYING THIS FIELD */
                    if (typeof row.conditional1 !== "undefined") {
                      //     conditional: "AGENT_TYPE === DIALOGFLOW",
                      var variables = formData.data;
                      variables["users"] = props.userDeep;
                      variables["users_roles"] = props.userDeep["roles"];
                      variables["admins"] = [];

                      /* KAD added this Jan 18, 2025 to pull admins from the new row adminEmails */
                      if (Array.isArray(myContext["data"]["adminEmails"])) {
                        for (
                          let x = 0;
                          x < myContext["data"]["adminEmails"].length;
                          x++
                        ) {
                          variables["admins"].push(
                            myContext["data"]["adminEmails"][x]
                          );
                        }
                      }

                      if (!evaluateDynamicLogic(row.conditional1, variables))
                        return <div key={i} className="row"></div>;
                    }

                    if (row.input_type === "none") return <></>;
                    // Hide this field if show_if_populated (when present) is not satisfied
                    if (!passesShowIfPopulated(row, formData.data)) return null;

                    /* Vik(Sep 15, 2025): Commented this as its not allow headers with show_if_populated field to be populated */
                    // if (
                    //   row.show_if_populated &&
                    //   (!(row.name in formData.data) ||
                    //     (row.name in formData.data &&
                    //       formData.data[row.name].length === 0))
                    // )
                    //   return <></>;

                    if ("instructions" in row) {
                      /* KAD added this July 31, 2025 */
                      return <></>;
                    }
                    if ("header" in row && row.type === "inline") {
                      // hide this header if its show_if_populated (if any) is not satisfied
                      console.log("inline :: ", { row, data: formData.data });

                      if (!passesShowIfPopulated(row, formData.data))
                        return null;
                      return (
                        <div
                          key={row.header}
                          style={
                            "colspan" in row && row.colspan === 3
                              ? props.style.gridStyle100
                              : props.style.gridStyle33
                          }
                        >
                          <div
                            className="common-from-sub-heading cursor-pointer"
                            onClick={() => {
                              if (false)
                                setIsShow((prev) => (prev === i ? -1 : i));
                            }}
                          >
                            <div className="leinfo">{row.header}</div>
                            {/* KAD took out Sept 6, 2025 temporarily
                            <button
                              type="button"
                              disabled
                              className={`accord-btn ${
                                isShow === i && "active"
                              }`}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={16}
                                height={16}
                                fill="currentColor"
                                className="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                />
                              </svg>
                            </button>
*/}
                          </div>
                        </div>
                      );
                    } else {
                      // hide this field if its show_if_populated (if any) is not satisfied
                      if (!passesShowIfPopulated(row, formData.data))
                        return null;
                      return (
                        (!Object.keys(menumap).length ||
                          i < Object.keys(menumap)[0] ||
                          (menumap[isShow] >= i && isShow <= i)) && (
                          <div
                            key={row.name}
                            //Style added for scrolling - Arpan
                            /* Vik(Jun 20, 2025): Changed styling to implement border and border radius arround fields */
                            style={
                              row.input_type === "mcp_client"
                                ? {
                                    ...props.style.gridStyle100,
                                    marginRight:
                                      i < row.length - 1 ? "16px" : "2px",
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    padding: "5px 5px 5px 5px",
                                    marginBottom: "15px",
                                  }
                                : {
                                    ...("colspan" in row && row.colspan === 3
                                      ? props.style.gridStyle100
                                      : {
                                          ...props.style.gridStyle33,
                                          marginRight:
                                            i < row.length - 1 ? "16px" : "2px",
                                        }),
                                    ...(row?.is_scrollable && {
                                      maxHeight:
                                        row?.scrollable_max_height ?? "250px",
                                      overflowX: "scroll",
                                    }),
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    padding: "5px 5px 5px 5px",
                                    marginBottom: "15px",
                                  }
                            }
                          >
                            <p style={props.style.displayName}>
                              {row.display_name}{" "}
                              {row.help && (
                                <Tooltip placement="top" title={row.help}>
                                  <InfoIcon />
                                </Tooltip>
                              )}{" "}
                            </p>
                            <p style={props.style.displayValue}>
                              {showField(row, formData)}
                            </p>
                          </div>
                        )
                      );
                    }
                  })}
                </div>
              ))}
          </div>
          <RowMargin />
          <Row>
            <Col style={{ width: 100 + "%" }}>
              {"subTables" in props.config &&
                // eslint-disable-next-line array-callback-return
                props.config.subTables.map((table) => {
                  if (table.collection in formData.data)
                    return (
                      <>
                        <SuperAppObject
                          depth={props.depth + 1}
                          style={props.style}
                          collection_name={table.collection}
                          allObjects={formData.data[table.collection]}
                          thisObject={props.thisObject}
                          config={props.config["subTables"][0]}
                          user={props.user}
                          userDeep={props.userDeep}
                          inputData={formData.data[table.collection]}
                          displayState="TABLE"
                          topLevelSave={props.topLevelSave}
                        />
                        <RowMargin />
                      </>
                    );
                  //return true;
                })}
              {/* Vik(Jul 14, 2025): Render file table with attachments, passing
              deletingFiles and handleFileDelete for spinner display during file
              deletion */}
              {"flags" in props.config &&
                props.config.flags.indexOf("attachments") >= 0 &&
                "attachments" in formData.data && (
                  <>
                    <SuperAppObject
                      depth={props.depth + 1}
                      style={props.style}
                      config={filesConfig}
                      user={props.user}
                      userDeep={props.userDeep}
                      collection_name="files"
                      inputData={attachments}
                      //inputData={formData.data["attachments"]}
                      displayState="FILE_TABLE"
                      deletingFiles={deletingFiles} // Pass deletingFiles state
                      setDeletingFiles={setDeletingFiles} // Pass setter
                      handleFileDelete={handleFileDelete} // Pass deletion handler
                    />
                    <RowMargin />
                  </>
                )}
              {!props.hideTrackingList && "tracking" in formData.data && (
                <>
                  <SuperAppObject
                    depth={props.depth + 1}
                    style={props.style}
                    config={trackingConfig}
                    user={props.user}
                    userDeep={props.userDeep}
                    collection_name="tracking"
                    inputData={formData.data["tracking"]}
                    displayState="TRACKING_TABLE"
                  />
                </>
              )}
            </Col>
          </Row>
        </Col>
        {props.showAgent && (
          <Col xs={12} lg={4}>
            <ShowAgent agent_id={formData.data["id"]} refreshKey={refreshKey} />
          </Col>
        )}
      </Row>
    </Container>
  );
}
